export default __webpack_public_path__ + "paris-bef33cd44b0f9097b6b2acdfcbd81d7a.bundle.jpg";